module.exports = __webpack_public_path__ + "media/images/img_graph_1-c9c71336b1033cf728ced5fbdcfd00c4.png";